<table class="table-calendar week-mode" (window:resize)="windowResized()">
	<!-- Days of week. -->
	<thead>
		<tr>
			<td class="col-hour"></td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[0].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 0 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.SUN.ABB' | translate | uppercase }}
					{{ arDays[0].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.SUN.FIRST' | translate | uppercase }}
					{{ arDays[0].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[0] > 0"
					class="badge"
					data-day="0"
					>{{ dayTotalEvents[0] }}</span
				>
			</td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[1].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 1 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.MON.ABB' | translate | uppercase }}
					{{ arDays[1].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.MON.FIRST' | translate | uppercase }}
					{{ arDays[1].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[1] > 0"
					class="badge"
					data-day="1"
					>{{ dayTotalEvents[1] }}</span
				>
			</td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[2].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 2 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.TUE.ABB' | translate | uppercase }}
					{{ arDays[2].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.TUE.FIRST' | translate | uppercase }}
					{{ arDays[2].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[2] > 0"
					class="badge"
					data-day="2"
					>{{ dayTotalEvents[2] }}</span
				>
			</td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[3].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 3 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.WED.ABB' | translate | uppercase }}
					{{ arDays[3].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.WED.FIRST' | translate | uppercase }}
					{{ arDays[3].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[3] > 0"
					class="badge"
					data-day="3"
					>{{ dayTotalEvents[3] }}</span
				>
			</td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[4].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 4 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.THU.ABB' | translate | uppercase }}
					{{ arDays[4].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.THU.FIRST' | translate | uppercase }}
					{{ arDays[4].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[4] > 0"
					class="badge"
					data-day="4"
					>{{ dayTotalEvents[4] }}</span
				>
			</td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[5].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 5 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.FRI.ABB' | translate | uppercase }}
					{{ arDays[5].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.FRI.FIRST' | translate | uppercase }}
					{{ arDays[5].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[5] > 0"
					class="badge"
					data-day="5"
					>{{ dayTotalEvents[5] }}</span
				>
			</td>
			<td
				(click)="calendarUtils.showEventsOfDay(arDays[6].date, showDayEvents)"
				[ngClass]="{
					activeDayOfWeek: activeDayOfWeek == 6 && currentWeekVisible
				}"
			>
				<span *ngIf="!isMobile"
					>{{ 'CALENDAR.WEEKDAYS.SAT.ABB' | translate | uppercase }}
					{{ arDays[6].day }}</span
				>
				<span *ngIf="isMobile"
					>{{ 'CALENDAR.WEEKDAYS.SAT.FIRST' | translate | uppercase }}
					{{ arDays[6].day }}</span
				>
				<span
					*ngIf="!isMobile && dayTotalEvents[6] > 0"
					class="badge"
					data-day="6"
					>{{ dayTotalEvents[6] }}</span
				>
			</td>
		</tr>
	</thead>

	<tbody [@tableAnimation]>
		<tr>
			<td colspan="8" style="padding: 0">
				<!-- While is loading. -->
				<div
					*ngIf="isLoading"
					style="margin-top: 60px; padding: 50px 20px; text-align: center"
				>
					<freud-loader size="sm" [bgColor]="false"></freud-loader>
				</div>

				<!-- List events. -->
				<div
					*ngIf="!isLoading"
					id="calendar-scroll-container"
					class="scroll-container"
					style="
						height: 380px;
						overflow-y: scroll;
						width: 101%;
						transition: height 300ms;
					"
				>
					<table
						class="table-calendar week-mode"
						style="border: none; position: relative"
					>
						<tbody class="events-tbody">
							<tr
								*ngFor="let hour of hours; let i = index"
								id="wh{{ hour.hour }}"
							>
								<!-- Coluna de hora -->
								<td
									class="td-no-border"
									style="width: 40px; vertical-align: top"
								>
									<div
										class="{{
											i > 0 && !(i % 2) ? 'week-hour' : 'week-hour-hidden'
										}} {{
											currentWeekVisible && hour.hour == hourIntervalNow
												? 'rowOfNow'
												: ''
										}}"
									>
										{{ hour.hour }}
									</div>
									<div
										class="line-hour-circle"
										*ngIf="currentWeekVisible && hour.hour == hourIntervalNow"
									></div>
								</td>
								<td class="grouped-col" colspan="7">
									<table class="table-week-content" style="height: 0">
										<tr
											[ngClass]="{
												rowOfNow:
													currentWeekVisible && hour.hour == hourIntervalNow
											}"
										>
											<!-- Coluna do evento -->
											<td
												*ngFor="
													let weekDay of hour?.weekEvents;
													let idx = index
												"
												[ngClass]="{
													activeDayOfWeek:
														activeDayOfWeek == idx && currentWeekVisible
												}"
												class="slot-container"
											>
												<div
													*ngFor="let busySlot of weekDay.busySlots"
													class="td-container calendar-event personal-session"
													(click)="
														calendarUtils.openDetailsModal(
															busySlot.id,
															'busyslot',
															showSelectedEvent
														)
													"
													[style.left]="
														weekDay.hasRecurrencyOverlaping ? '30px' : '0px'
													"
													[style.height]="busySlot.calendarHeight"
													[style.top]="busySlot.calendarOffset"
												>
													<div *ngIf="!isMobile" class="week-event-item zk-flex-col">
														<p
															class="sec-title"
															[ngClass]="{
																'small-busyslot': busySlot.isQuarterHour
															}"
														>
															{{ busySlot?.description }}
														</p>
														<p
															*ngIf="busySlot.duration >= 45"
															ev-paid
															class="sec-subtitle"
														>
															{{
																dateTime.getFormatedHours(busySlot.startDate)
															}}
														</p>
													</div>
													<div *ngIf="isMobile" class="week-event-item zk-flex-col"></div>
												</div>
												<div
													*ngFor="let event of weekDay.events"
													title="{{
														event.status !== 'reserved'
															? event.calendarTime
															: ('GENERAL.PENDING' | translate)
													}}"
													class="td-container calendar-event {{ event.status }}"
													[ngClass]="{
														'face-to-face-session': event.professionalAddress,
														'online-session': !event.professionalAddress,
														'invite-pending-session': event.status === 'invite' && event.origin === 'invite' ||  event.status === 'reschedule_request',
												      	'invite-paid-session': event.status === 'paid' && event.origin === 'invite'
													}"
													(click)="
														calendarUtils.openDetailsModal(
															event.id,
															'event',
															showSelectedEvent,
															event
														)
													"
													[style.height]="event.calendarHeight"
													[style.left]="
														weekDay.hasRecurrencyOverlaping ? '30px' : '0px'
													"
													[style.top]="event.calendarOffset"
												>
													<div
														class="
															week-event-item
															zk-flex zk-justify-between zk-w-full zk-flex-row	
														"
													>
														<div class="title-wraper">
															<p class="sec-title">
																<span *ngIf="event.status === 'reschedule'" class="freud-icon freud-icon-calendar-time"></span>
																<span *ngIf="event.status === 'reschedule_request'" class="freud-icon freud-icon-send"></span>
																<span *ngIf="event.status === 'invite' && event.origin === 'invite'" class="freud-icon freud-icon-send"></span>
																{{
																	event.status !== 'reserved'
																		? event.userName
																		: ('GENERAL.PENDING' | translate)
																}}
															</p>
															<p
																*ngIf="event.duration >= 45"
																class="sec-subtitle"
															>
																{{ event.calendarTime }}
															</p>
														</div>
														<div class="icons-wrapper">
															<div
																*ngIf="event.recurringScheduleId"
																freud-tooltip
																[tooltipLabel]="
																	event.recurringScheduleId
																		? ('GENERAL.RECURRENCY_SESSION' | translate)
																		: null
																"
																tooltipPosition="right"
															>
																<span class="freud-icon freud-icon-sync"></span>
															</div>
															<div
																*ngIf="event.triageId"
																freud-tooltip
																[tooltipLabel]="
																	event.triageId
																		? ('GENERAL.AVAILABLE_TRIAGE' | translate)
																		: null
																"
																tooltipPosition="right"
															>
																<span
																	class="freud-icon freud-icon-list-check"
																></span>
															</div>
														</div>
													</div>
													<div *ngIf="isMobile" class="week-event-item"></div>
												</div>
												<calendar-slot-recurency-attempt
													*ngFor="
														let recurrencyAttempt of weekDay.recurrencyAttempts
													"
													[recurrencyAttempt]="recurrencyAttempt"
													(onOpenDetails)="
														calendarUtils.openDetailsModal(
															$event.overlapEventId,
															$event.reason ===
																'DatetimeReservedForAnotherSession'
																? 'event'
																: 'busyslot',
															showSelectedEvent
														)
													"
												></calendar-slot-recurency-attempt>
												<div
													[ngClass]="{
														'slot-without-events':
															calendarAvailabilitiesService.isSlotAvailable(
																avaibilitiesForWeek,
																weekDay.luxonDate
															),
														slotAvailable:
															calendarAvailabilitiesService.isSlotAvailable(
																avaibilitiesForWeek,
																weekDay.luxonDate
															),
														slotAvailableToday:
															calendarAvailabilitiesService.isSlotAvailable(
																avaibilitiesForWeek,
																weekDay.luxonDate
															) &&
															activeDayOfWeek == idx &&
															currentWeekVisible,
														slotUnavailable:
															!calendarAvailabilitiesService.isSlotAvailable(
																avaibilitiesForWeek,
																weekDay.luxonDate
															)
													}"
													(click)="
														calendarUtils.createEvent(
															weekDay.luxonDate,
															showSelectedEvent
														)
													"
												></div>
											</td>
										</tr>
									</table>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</td>
		</tr>
	</tbody>
</table>
